import { getAppConfig } from 'App/AppWithConfig'

export const triggerGtmEvent = (dataLayerProps) => {
  const {
    ids: { gtm: gtmId },
  } = getAppConfig()

  const gtmArgs = {
    gtmId,
    ...(dataLayerProps && { dataLayer: dataLayerProps }),
    // Making it always read from the window.dataLayer
    dataLayerName: 'dataLayer',
  }

  // Disable GTM for non-production builds
   if (process.env.NODE_ENV === 'production') {
    if (window.dataLayer) {
      // If dataLayer already exists, push the events directly
      window.dataLayer.push(gtmArgs.dataLayer, gtmArgs.dataLayerName)
    } else {
      // Otherwise, initialize GTM
      window.dataLayer = [gtmArgs]
      // Load GTM script dynamically
      ;(function (w, d, s, l, i) {
        w[l] = w[l] || []
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
        var [f] = d.getElementsByTagName(s),
          j = d.createElement(s),
          dl = l !== 'dataLayer' ? '&l=' + l : ''
        j.async = true
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
        f.parentNode.insertBefore(j, f)
      })(window, document, 'script', 'dataLayer', gtmId)
    }
  }
}
